import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router} from '@angular/router';
import {RoleService} from '@services/role.service';

@Injectable({providedIn: 'root'})
export class RoleGuard implements CanActivate {
    constructor(
        private roleService: RoleService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const allowedRoles: string[] = route.data['roles'];
        const currentRole = this.roleService.getRole();

        if (allowedRoles?.includes(currentRole)) {
            return true;
        }

        this.router.navigate(['/']);
        return false;
    }
}
